import script from "./UserDataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDataTable.vue?vue&type=script&lang=ts&setup=true"

import "./UserDataTable.vue?vue&type=style&index=0&id=3f8212e1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8212e1"]])

export default __exports__